"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchableCollection = void 0;
var SearchableCollection;
(function (SearchableCollection) {
    SearchableCollection["ANALYSES"] = "analyses";
    SearchableCollection["ARTICLES"] = "articles";
    SearchableCollection["CODE_ARTICLES"] = "codeArticles";
    SearchableCollection["DECISIONS"] = "decisions";
    SearchableCollection["GLOSSARY_TERMS"] = "glossaryTerms";
    SearchableCollection["LAW_TEXTS"] = "laws";
    SearchableCollection["PUBLICATION_SHEETS"] = "publicationSheets";
    SearchableCollection["STATISTICS"] = "statistics";
})(SearchableCollection || (exports.SearchableCollection = SearchableCollection = {}));
//# sourceMappingURL=searchableCollections.js.map